import { useData } from "../../hooks/useData";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

// JSON-driven announcement bar (light theme).
export default function AnnouncementBar() {
  const { data } = useData("notifications");
  const [open, setOpen] = useState(true);
  if (!data || !data.enabled) return null;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
          className="relative z-50 overflow-hidden bg-brand-gradient text-white"
          data-testid="announcement-bar"
        >
          <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-5 py-2.5 text-center text-sm">
            <span>{data.text}</span>
            {data.link && (
              <Link to={data.link} className="hidden shrink-0 font-semibold underline underline-offset-4 sm:inline" data-testid="announcement-link">
                {data.linkLabel || "Learn more"}
              </Link>
            )}
            <button onClick={() => setOpen(false)} className="absolute right-4 text-white/80 hover:text-white" data-testid="announcement-close" aria-label="Close">
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
